<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_binder") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 p4">
			<create-update-form @submit="handleSubmit">
				<div
					class="flex xs-12 xs-between mt6"
					slot="actions"
					slot-scope="{ onSubmit }"
				>
					<j-button :isLoading="isLoading" @click="onSubmit">
						{{ $t("create_binder") }}
					</j-button>
					<j-button
						type="bordered"
						@click="$router.push({ name: 'BindersList' })"
					>
						{{ $t("cancel") }}
					</j-button>
				</div>
			</create-update-form>
		</j-card>
	</core-layout-content>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CreateUpdateForm from "../components/CreateUpdateForm"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreFormInput,
		JCard,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CreateUpdateForm
	},

	data: () => ({
		isLoading: false
	}),

	methods: {
		async handleSubmit(payload, facts) {
			const query = gql`
				mutation createBinder($input: binderInput!) {
					createBinder(input: $input) {
						status
						createdStatus {
							id
						}
						errors
					}
				}
			`

			const queryAddFact = gql`
				mutation addFactToBinder($binderId: String!, $input: addFactInput!) {
					addFactToBinder(binderId: $binderId, input: $input) {
						status
						errors
					}
				}
			`

			// 1: Create binder
			this.isLoading = true
			const res = await api({ query, variables: { input: { ...payload } } })

			if (res?.data?.createBinder?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.createBinder?.errors[0] || this.$t("errors.general")
				)
				this.isLoading = false
				return
			}

			// 2: Add all facts to created binder
			const binderId = res?.data?.createBinder?.createdStatus?.id
			const factsRes = await Promise.all(
				facts.map(item =>
					api({
						query: queryAddFact,
						variables: {
							binderId,
							input: { type: item.type, value: item.value }
						}
					})
				)
			)

			// Check errors for facts adding
			if (
				factsRes.find(item => item?.data?.addFactToBinder?.status !== "success")
			) {
				this.$store.dispatch(
					"showError",
					"There was an error, please try to create this binder again"
				)
				this.isLoading = false
				return
			}

			// Succes - redirect
			this.isLoading = false
			this.$router.push({
				name: "BindersList"
			})
		}
	}
}
</script>
